"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyAssistedConnectionStatus = exports.CompanyAutomatedConnectionStatus = exports.TokenStatus = void 0;
/**
 * ApplicationStatus is an ENUM for indicating the type of Finch Application.
 */
var TokenStatus;
(function (TokenStatus) {
    TokenStatus["UNSPECIFIED"] = "UNSPECIFIED";
    TokenStatus["AUTOMATED_HEALTHY"] = "AUTOMATED_HEALTHY";
    TokenStatus["AUTOMATED_REAUTH"] = "AUTOMATED_REAUTH";
    TokenStatus["AUTOMATED_DISCONNECTED"] = "AUTOMATED_DISCONNECTED";
    TokenStatus["ASSISTED_PENDING"] = "ASSISTED_PENDING";
    TokenStatus["ASSISTED_PROCESSING"] = "ASSISTED_PROCESSING";
    TokenStatus["ASSISTED_CONNECTED"] = "ASSISTED_CONNECTED";
    TokenStatus["ASSISTED_DISCONNECTED"] = "ASSISTED_DISCONNECTED";
})(TokenStatus = exports.TokenStatus || (exports.TokenStatus = {}));
/**
 * CompanyAutomatedConnectionStatus is an ENUM for company level connection status for automated applications.
 */
var CompanyAutomatedConnectionStatus;
(function (CompanyAutomatedConnectionStatus) {
    CompanyAutomatedConnectionStatus["CONNECTED"] = "CONNECTED";
    CompanyAutomatedConnectionStatus["WARNING"] = "WARNING";
    CompanyAutomatedConnectionStatus["DISCONNECTED"] = "DISCONNECTED";
})(CompanyAutomatedConnectionStatus = exports.CompanyAutomatedConnectionStatus || (exports.CompanyAutomatedConnectionStatus = {}));
/**
 * CompanyAssistedConnectionStatus is an ENUM for company level connection status for assisted applications.
 */
var CompanyAssistedConnectionStatus;
(function (CompanyAssistedConnectionStatus) {
    CompanyAssistedConnectionStatus["PENDING"] = "PENDING";
    CompanyAssistedConnectionStatus["PROCESSING"] = "PROCESSING";
    CompanyAssistedConnectionStatus["CONNECTED"] = "CONNECTED";
    CompanyAssistedConnectionStatus["DISCONNECTED"] = "DISCONNECTED";
    CompanyAssistedConnectionStatus["UNSPECIFIED"] = "UNSPECIFIED";
})(CompanyAssistedConnectionStatus = exports.CompanyAssistedConnectionStatus || (exports.CompanyAssistedConnectionStatus = {}));
